/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/25
 */

const scrollToTop = (top = window.scrollY, max = 80) => {
  const next = top - 50;
  if (next > max) {
    window.scrollTo(0, next);
    setTimeout(() => scrollToTop(next, max), 1)
  } else {
    window.scrollTo(0, max);
  }
};

export default scrollToTop;



// WEBPACK FOOTER //
// ./src/utils/scrollToTop.js